// extracted by mini-css-extract-plugin
export default {"customTextArea":"styles_customTextArea__xPV38"};